import "./EmojiMartPicker.scss";

import React from "react";
// import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import data from '@emoji-mart/data/sets/14/twitter.json'

const EmojiMartPicker = ({
    set='apple',
    ...otherProps
}) => {

    return  <Picker
        data={data}
        emojiVersion={11}
        set={set}
        previewPosition={'none'}
        skinTonePosition={'none'}
        autoFocus={true}
        navPosition={'none'}
        theme={'light'}
        {...otherProps}
    />

}

export default EmojiMartPicker;